export interface TokenDetails {
  access: string;
  refresh: string;
  first_login_attempt?: boolean;
}

export enum Authorities {
  'AGENT' = 'AGENT',
  'SUPPORT' = 'SUPPORT',
  'SUPERADMIN' = 'SUPERADMIN',
  /** Mobile User */
  'USER' = 'USER'
}

export interface TMSTokenDetails {
  user_name: string;
  scope: ['READ', 'WRITE'];
  roles: string[];
  exp: number;
  userId: number;
  authorities: Authorities[];
  jti: string;
  client_id: 'clientId';
  /** Admin Email */
  email: string;

  /** Mobile User Mobile Number */
  sub: string;
  /** Mobile User Customer ID */
  subisuCustomerId: string;
}

function setToken(token: TokenDetails) {
  try {
    localStorage.setItem('auth', JSON.stringify(token));
  } catch (e) {
    console.error('Error storing token', e);
  }
}

function getToken() {
  try {
    return JSON.parse(localStorage.getItem('auth') || '') as TokenDetails;
  } catch (e) {
    return null;
  }
}

function getTokenDetails() {
  try {
    const token = getToken();
    return token ? (JSON.parse(window.atob(token.access.split('.')[1])) as TMSTokenDetails) : null;
  } catch (e) {
    return null;
  }
}

function isAuthenticated() {
  const tokenDetails = getTokenDetails();
  if (tokenDetails) {
    return tokenDetails.exp * 1000 > Date.now();
  } else {
    return false;
  }
}

function checkRBAC(authorities: Authorities[]) {
  const tokenDetails = getTokenDetails();
  if (tokenDetails) {
    return tokenDetails.authorities?.find((authority) => authorities.includes(authority));
  } else {
    return false;
  }
}

function clearToken() {
  localStorage.removeItem('auth');
}

const TokenService = {
  setToken,
  getToken,
  getTokenDetails,
  isAuthenticated,
  checkRBAC,
  clearToken
};

export default TokenService;
